/* Dashboard services */
import { request } from "../../Services/Api"

export const getDashboardData = ({ chartType, ...params }) =>
  request.api.get(`/dashboard/charts/${chartType}/`, params)
export const getAllBusinessAccountsList = () =>
  request.api.get(`/dashboard/charts/by_business_accounts_list/`)
export const getDashboardStatistics = (params) =>
  request.api.get(`/dashboard/charts/statistics/`, params)

// The alert flow (source -> outcome) needs the joint distribution: alert_service x
// alert_status counts/volumes, already aggregated server-side (CHA1-2007).
export const getAlertsFlow = (params) => request.api.get(`/dashboard/charts/alert_flow/`, params)
